import React from "react";
import { Link } from "react-router-dom";

function EmissionActionsCard({ language, btnBack, isSubmitting }) {
  const t = {
    EN: {
      legal: "By submitting this form, you agree to our ",
      privacy: "Privacy Policy.",
      back: "Back",
      sending: "Submitting...",
      next: "Next",
    },
    ES: {
      legal: "Al enviar este formulario, aceptás nuestra ",
      privacy: "Política de Privacidad.",
      back: "Volver",
      sending: "Enviando...",
      next: "Siguiente",
    },
  };

  return (
    <div className="containerFlex">
      <div className="card flexBetween">
        <div>
          <p className="legal">
            {t[language].legal}
            <Link to="/privacy" target="_blank">
              {t[language].privacy}
            </Link>
          </p>
        </div>

        <div>
          <button type="button" onClick={btnBack} disabled={isSubmitting}>
            {t[language].back}
          </button>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? t[language].sending : t[language].next}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EmissionActionsCard;
